import { useEffect, useState } from "react";
import { api, formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { UserX, Check, X } from "lucide-react";
import { toast } from "sonner";

export default function DeletionRequests({ onChanged }) {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/deletion-requests", { params: { status: "pending" } }).then(({ data }) => setItems(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const decide = async (r, action) => {
    const msg = action === "approve"
      ? `Désactiver le compte de ${r.user_name} ? Ses données seront conservées.`
      : `Refuser la demande de ${r.user_name} ?`;
    if (!window.confirm(msg)) return;
    try {
      await api.post(`/admin/deletion-requests/${r.id}/${action}`);
      toast.success(action === "approve" ? "Compte désactivé" : "Demande refusée");
      load();
      onChanged?.();
    } catch (e) { toast.error(formatError(e)); }
  };

  if (items.length === 0) return null;
  return (
    <div className="ek-card p-0 border-2 border-[#E6B800]/50" data-testid="deletion-requests-panel">
      <div className="px-4 py-3 border-b border-[#E2E8F0] flex items-center gap-2">
        <UserX className="w-5 h-5 text-[#B38F00]" />
        <h2 className="font-bold" style={{ fontFamily: "Outfit" }}>Demandes de suppression de compte</h2>
        <span className="text-xs font-bold bg-[#E6B800] text-[#1A2E28] rounded-full px-2 py-0.5">{items.length}</span>
      </div>
      {items.map((r) => (
        <div key={r.id} className="px-4 py-3 border-b border-[#E2E8F0] last:border-0 flex items-center gap-3 flex-wrap" data-testid={`deletion-request-${r.username}`}>
          <div className="flex-1 min-w-[200px]">
            <div className="font-semibold text-sm">{r.user_name} <span className="text-[#5C736A] font-normal">@{r.username}</span></div>
            <div className="text-xs text-[#5C736A]">Le {new Date(r.created_at).toLocaleDateString("fr-FR")}{r.motif ? ` · « ${r.motif} »` : ""}</div>
          </div>
          <Button size="sm" variant="outline" onClick={() => decide(r, "reject")} data-testid={`reject-deletion-${r.username}`}><X className="w-4 h-4 mr-1" /> Refuser</Button>
          <Button size="sm" onClick={() => decide(r, "approve")} className="bg-red-600 hover:bg-red-700 text-white" data-testid={`approve-deletion-${r.username}`}><Check className="w-4 h-4 mr-1" /> Désactiver le compte</Button>
        </div>
      ))}
    </div>
  );
}
